import api from '@app/services/api';
import type { ApiError, ClientListParams, ClientListResponse } from '@app/services/api.types';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

type QueryOptions = Omit<UseQueryOptions<ClientListResponse, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchClientsList = async (params: ClientListParams): Promise<ClientListResponse> => {
    const url = apiEndpoints.users.getList(params);
    const response = await api.get(url);
    return response?.data?.data;
};

const useClientsList = (params: ClientListParams, options?: QueryOptions) => {
    return useQuery<ClientListResponse, ApiError>({
        queryKey: ['user', 'list', params],
        queryFn: () => fetchClientsList(params),
        ...options,
    });
};

export default useClientsList;

